import type { Dayjs, ManipulateType } from 'dayjs';

import {
  SIGNAL_DATE_PRESET,
  type SIGNAL_PERIOD,
  type SignalDateSelectionInput,
} from '../model';
import {
  parseSignalDatePreset,
  resolveSignalDateRange,
} from './signal-date-preset.utils';

export type NormalizedQueryRange = {
  startDate: string;
  endDate: string;
  // period는 시각화/집계 단위이며 query scope(start/end)를 바꾸면 안 됩니다.
  period: SIGNAL_PERIOD;
};

export type DayBasedPresetPolicy = {
  days: number;
  period: SIGNAL_PERIOD;
};

export type HourBasedPresetPolicy = {
  hours: number;
  period: SIGNAL_PERIOD;
};

export const DAY_BASED_PRESET_POLICY: Record<string, DayBasedPresetPolicy> = {
  [SIGNAL_DATE_PRESET.PAST_7_DAYS]: (() => {
    const parsed = parseSignalDatePreset(SIGNAL_DATE_PRESET.PAST_7_DAYS);
    return {
      days: parsed.value,
      period: parsed.unit,
    };
  })(),
  [SIGNAL_DATE_PRESET.PAST_30_DAYS]: (() => {
    const parsed = parseSignalDatePreset(SIGNAL_DATE_PRESET.PAST_30_DAYS);
    return {
      days: parsed.value,
      period: parsed.unit,
    };
  })(),
  [SIGNAL_DATE_PRESET.PAST_90_DAYS]: (() => {
    const parsed = parseSignalDatePreset(SIGNAL_DATE_PRESET.PAST_90_DAYS);
    return {
      days: parsed.value,
      period: parsed.unit,
    };
  })(),
};

export const HOUR_BASED_PRESET_POLICY: Record<string, HourBasedPresetPolicy> = {
  [SIGNAL_DATE_PRESET.PAST_24_HOURS]: (() => {
    const parsed = parseSignalDatePreset(SIGNAL_DATE_PRESET.PAST_24_HOURS);
    return {
      hours: parsed.value,
      period: parsed.unit,
    };
  })(),
  [SIGNAL_DATE_PRESET.PAST_3_DAYS]: (() => {
    const parsed = parseSignalDatePreset(SIGNAL_DATE_PRESET.PAST_3_DAYS);
    return {
      hours: parsed.value,
      period: parsed.unit,
    };
  })(),
};

export const normalizeUtcBoundary = (params: {
  now: Dayjs;
  amount: number;
  unit: ManipulateType;
  boundary: 'start' | 'end';
}) => {
  const base = params.now.subtractVal(params.amount, params.unit);
  if (params.boundary === 'start') {
    return base.startOf(params.unit).toJSON();
  }
  return base.endOf(params.unit).toJSON();
};

export const normalizeSignalPresetForQuery = (
  selection: SignalDateSelectionInput,
): NormalizedQueryRange => {
  const range = resolveSignalDateRange(selection);
  return {
    startDate: range.queryStart,
    endDate: range.queryEnd,
    period: range.period,
  };
};

export const getPresetQueryPeriod = (
  selection: SignalDateSelectionInput,
): SIGNAL_PERIOD => resolveSignalDateRange(selection).period;
